<div class='upsell-doc'>
  <div class="upsell-doc__container p-4 mt-8 mx-auto desktop:flex gap-12">
    <div class='upsell-doc__image w-40 shrink-0 mx-auto'><img [src]='docPicLink'/>
      <div class='upsell-doc__authorBio italic text-sm font-light text-center mt-2 mb-8'>
        <p class="text-gray-500">Dr. John Layke<br>Cosmetic Surgeon and<br>Creator of the Beverly<br>Hills MD Skin Care Line</p>
      </div>
    </div>
    <div class="upsell-doc__text" [innerHTML]="docText"></div>
  </div>
</div>